<template>
    <div>
        <!-- Clonar Modal -->
        <div class="modal fade" id="clonarSoliciAutorizModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Clonar Solicitação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="solic">
                        <div class="alert alert-info">
                            <div class="lead">
                                {{ solic.paciente ? solic.paciente.st_nome : solic.cadastro_temporario.st_nome }}
                            </div>
                            <div>
                                {{ solic.procedimento.search }}
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input 
                                    label="Data da Solicitação"
                                    type="date"
                                    v-model="solic.dt_solicitacao"  />
                            </div>
                        </div>

                        <div class="form-row mt-3">
                            <div class="col col-12">
                                <az-input 
                                    label="Mesmo Procedimento"
                                    type="checkbox-group"
                                    v-model="mesmo_procedimento" />
                            </div>
                        </div>

                        <template v-if="!mesmo_procedimento && solic">

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        placeholder="Selecionar procedimento..."
                                        icon="fa-solid fa-play fa-fw"
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="procedimentos.index" 
                                        :optionsParm="{
                                            agenda: 1, 
                                            agenda_add: 1, 
                                            ativos: 1, 
                                            // id_medico: solic.id_medico, 
                                            sus: solic.fl_apac ? 1 : 0, 
                                            id_plano: solic.plano ? solic.plano.id_plano : '',
                                            id_operadora: solic.plano ? solic.plano.id_operadora : '',
                                            id_unidade_operacao: solic.id_unidade_operacao 
                                        }"
                                        :procsigla="true"
                                        :edicao="!medico"
                                        required
                                        :validate="validate"
                                        v-model="procedimento" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        icon="fa-solid fa-user-doctor fa-fw"
                                        placeholder="Selecione o Profissional..."
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="medicos.index"
                                        :optionsParm="{
                                            ativos: true,
                                            agenda: true,
                                            id_procedimento: procedimento ? procedimento.id_procedimento : null
                                        }"
                                        required
                                        :edicao="!!procedimento"
                                        :validate="validate"
                                        v-model="medico" />
                                </div>
                            </div>

                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar">Clonar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';


export default {
    data() {
        return { 
            solic: null, 
            mesmo_procedimento: true, 
            mesmo_medico: true, 
            procedimento: null, 
            medico: null, 
            validate: false, 
        }
    },

    components: { 
        AzInput,
        AzSubmit, 
    },

    methods: { 
        abrir (solic) { 
            this.mesmo_procedimento = true;
            this.procedimento = null;
            this.medico = null; 
            this.validate = false;
            
            this.solic = _.cloneDeep(solic);

            $('#clonarSoliciAutorizModal').modal('show');
        },

        atualizar () { 
            if ( !confirm('Confirmar clonar essa solicitação para da data informada?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'clonar',
                dados: { 
                    id_solicitacao_autorizacao: this.solic.id_solicitacao_autorizacao,
                    dt_solicitacao: this.solic.dt_solicitacao,
                    id_procedimento: ( this.mesmo_procedimento || !this.procedimento ) ? null : this.procedimento.id_procedimento,
                    id_medico: ( this.medico && !this.mesmo_procedimento ) ? this.medico.id_pessoa : null,
                },
                modal: 'clonarSoliciAutorizModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

    }
}
</script>
